import * as React from "react";
import {Redirect, Route, RouteComponentProps, Switch} from "react-router";
import {connect} from "react-redux";
import {RootState} from "../store/reducer/root/RootState";
import Routes from "./route/Route";
import ForgotPasswordPage from "../components/auth/ForgotPasswordPage";
import TermOfServicePage from "../components/auth/TermOfServicePage";
import User from "../model/user/User";
import {Option} from "ts-option";
import LogInPage from "../components/auth/LogInPage";
import NewPasswordPage from "../components/auth/NewPasswordPage";
import AccessDisablePage from "../components/auth/AccessDisablePage";

interface ReduxProps {
	/**
	 * User detail
	 */
	user: Option<User>;
}

type Props = ReduxProps & RouteComponentProps<{}>;

/**
 * Authorization component.
 */
class AuthRouter extends React.Component<Props, {}> {
	render() {
		if (this.props.location.pathname == Routes.ResetPassword) {
			return <Route key={"reset-password"}
						  path={this.props.match.url + "/reset-password"}
						  location={this.props.location}
						  component={NewPasswordPage}/>
		}

		if (this.props.user.isDefined) {
			if (!this.props.user.get.hasLoginPerm())
				return <Route component={AccessDisablePage}/>;

			if (!this.props.user.get.hasAcceptedToS())
				return <Route component={TermOfServicePage}/>;

			if (this.props.location.state)
				return <Redirect to={this.props.location.state.from}/>;
			else
				return <Redirect to={"/app"}/>;
		}
		return (
			<Switch>
				<Route key={"forgot-password"} path={this.props.match.url + "/forgot-password"} component={ForgotPasswordPage}/>
				<Route key={"signin"} component={LogInPage}/>
			</Switch>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user
	}
}

export default connect(mapStateToProps)(AuthRouter)